<template>
  <v-row class="px-8">
    <v-col>
      <v-autocomplete
        :items="revisions"
        item-value="uuid"
        :item-text="item => `Revision #${item.order} - ${item._created}`"
        hide-details
        label="Revision"
        solo
        v-model="selectedRevision"
      >
      </v-autocomplete>
    </v-col>
  </v-row>
</template>

<script>
import orderBy from 'lodash.orderby'
import { sync } from 'vuex-pathify'
import { format } from 'date-fns'

export default {
  name: 'TrafficMessageRevisionSelect',

  computed: {
    selectedRevision: sync('history/selectedTrafficMessageUUID'),

    revisions() {
      return orderBy(
        this.$store.get('history/trafficMessages'),
        ['created'],
        ['asc']
      ).map((x, i) => ({
        ...x,
        _created: format(new Date(x.created), 'yyyy-MM-dd HH:mm'),
        order: i + 1
      }))
    }
  },

  watch: {
    selectedRevision(value) {
      const trafficMessage = this.revisions.find(x => x.uuid === value)
      this.$store.set('trafficMessage/model', Object.assign({}, trafficMessage))
    }
  }
}
</script>
